import React from 'react'
import { HTMLOverlay } from 'react-map-gl'
import styled from 'styled-components'
import Anime from '../Animation/Anime'
import { fadeIn, fadeOut } from '../Animation/Animations'
import { toRGBA } from '../../utils'

const Overlay = styled.div`
  height: 100%;
  background: ${({ theme }) => toRGBA(theme.colors.greys.dark, 0.9, -1)};
`

const FillOverlay = ({ show }) => (
  <Anime
    in={show}
    enter={fadeIn({ duration: 2000 })}
    exit={fadeOut({ duration: 1000 })}
  >
    <HTMLOverlay redraw={x => <Overlay />} style={{ zIndex: 2 }} />
  </Anime>
)

export default FillOverlay
